import { usePage } from "@inertiajs/react";
import AppLayout from "@/layout/AppLayout";
import Avatar from "@/components/app/Avatar";
import BoardGameList from "@/components/app/BoardGameList";
import { ExternalLink } from "lucide-react";

export default function GameLibraryShow() {
  const { library_user, games } = usePage().props;

  return (
    <AppLayout>
      <div className="container py-8 max-w-4xl mx-auto">
        <div className="flex items-center gap-4 mb-6">
          <Avatar user={library_user} size="md" />
          <div>
            <h1 className="text-2xl font-bold">{library_user.full_name}&apos;s Library</h1>
            {library_user.bgg_username && (
              <a
                href={`https://boardgamegeek.com/user/${library_user.bgg_username}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-xs text-primary flex items-center gap-1 hover:underline"
              >
                {library_user.bgg_username}
                <ExternalLink className="h-3 w-3" />
              </a>
            )}
          </div>
        </div>

        <BoardGameList
          games={games}
          mode="library"
          hasBgg={!!library_user.bgg_username}
        />
      </div>
    </AppLayout>
  );
}
